import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IBtCreditCard } from '../../interfaces/braintree.interfaces';

@Component({
  standalone: true,
  selector: 'equine-ui-nx-bt-credit-card-selector-item',
  imports: [CommonModule],
  templateUrl: './bt-credit-card-selector-item.component.html',
  styleUrl: './bt-credit-card-selector-item.component.scss',
})
export class BtCreditCardSelectorItemComponent {
  @Input() cc!: IBtCreditCard;
  @Input() selectedToken: string | null  = null;
}
